import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * A sponsor's sales representative, built from `/admin/sponsors/:id/representatives` JSON
 * (hub `data-models/sponsor-representative.ts`). The hub's audit ids are not mapped.
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class SponsorRepresentative extends Base {
  // Writable via POST / PUT /admin/sponsors/:id/representatives
  name?: string | null;
  title?: string | null;
  territory?: string | null;
  phone?: string | null;
  email?: string | null;

  // Read-only
  sponsorId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.title = nullableString(source['title']);
    this.territory = nullableString(source['territory']);
    this.phone = nullableString(source['phone']);
    this.email = nullableString(source['email']);
    this.sponsorId = nullableString(source['sponsorId']);
  }
}
